import * as React from 'react';

import styled, { css } from 'styled-components';

import Hint from '@components/basics/hint';
import Flex from '@components/layout/flex';
import Button from '@components/actions/button';
import BoxTitleHeader from '../box-title-header';
import PlusIcon from '@components/basics/icons/plus';

interface BoxHeaderProps {
  className?: string;
  title: React.ReactNode;
  text?: React.ReactNode;
  customAction?: React.ReactNode;
  hasButton?: boolean;
  buttonClose?: boolean;
  btnBig?: boolean;
  hasHint?: boolean;
  hintText?: string | React.ReactElement;
  noMargin?: boolean;
  onClick?: (ev: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

export const BoxHeader: React.FC<BoxHeaderProps> = (props) => (
  <Flex
    className={props.className}
    justifyContent="space-between"
    alignItems="center"
  >
    <BoxTitleHeader
      bigTitle={props.btnBig ? true : false}
      title={props.title}
      text={props.text}
    />
    {props.hasButton ? (
      <Button
        className="cross-btn"
        buttonType="add"
        small={props.btnBig ? false : true}
        onClick={(ev) => (props.onClick ? props.onClick(ev) : null)}
      >
        <PlusIcon close={props.buttonClose} size={12} />
      </Button>
    ) : null}
    {props.hasHint ? (
      <Hint noTitle weight="700">
        {props.hintText}
      </Hint>
    ) : props.customAction ? (
      props.customAction
    ) : null}
  </Flex>
);

export default styled(BoxHeader)`
  ${(props) =>
    props.noMargin || props.hasHint
      ? null
      : css`
          margin-bottom: 20px;
        `}

  .cross-btn {
    flex-shrink: 0;
    margin-left: 10px;
  }
`;
